import { Boletagem } from "../boletagem";

export enum BoletagemAnexoTipo {
  "Contrato Garantia" = "CG",
  "Contrato Jurídico" = "CJ",
}

export interface BoletagemAnexo {
  readonly id?: number | null;
  readonly boletagem?: Boletagem | null;
  readonly tipo?: BoletagemAnexoTipo | null;
  readonly storagePath?: string | null;
  readonly originalFilename?: string | null;
}
